import React, { useEffect, useState } from "react";
import NumberFlow from "@number-flow/react";
import { Loader2 } from "lucide-react";

function Dailies({ site, period }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDailiesData = async () => {
      setLoading(true); // Reset loading state for every new API call

      try {
        console.log(`Fetching Dailies data for: ${site}`);

        const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No authentication token found. Please log in.");
        }

        const response = await fetch(
          `/.netlify/functions/fetchDailies?site=${site}&range=${period}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();
        console.log("Fetched Dailies Data:", result);

        // If the API response is nested, for example { data: { total_payout_usd: 123 } },
        // extract the nested data. Otherwise, use the result directly.
        const fetchedData = result.data ? result.data : result;
        setData(fetchedData);
      } catch (err) {
        console.error("Error fetching Dailies data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDailiesData();
  }, [site, period]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
      </div>
    );
  }
  if (error) {
    return <p className="text-red-500">Error: {error}</p>;
  }

  // Convert the value to a number.
  // Note: If data.total_payout_usd is 0, it will still be converted correctly.
  const totalPayout = data ? Number(data.total_payout) : 0;

  return (
    <div className="flex flex-row gap-16 px-6 py-3">
      <div className="flex flex-col gap-3 items-center">
        <p className="text-sm text-gray-400">Total Opened</p>
        <NumberFlow
          value={totalPayout}
          prefix="$"
          className="text-red-500 text-2xl font-bold"
        />
      </div>
    </div>
  );
}

export default Dailies;
